<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col">
          <h1 class="text-white pt-3 px-3">สรุปข้อมูลการขายพัสดุ</h1>
          <p class="text-white pb-0 px-3">
            แสดงข้อมูลการขายพัสดุทั้งหมดของสาขา
            โดยสามารถเลือกวันที่สามารถมาแสดงผลได้
          </p>
        </div>
        <div
          class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
          <h1 class="display-3 text-white">
            <small>ยอดรวมทั้งหมด :</small>
            {{ total | numFormat("0,0.00") }}
            <small>บาท</small>
          </h1>
          <button
            class="btn btn-warning btn-sm-res btn-flash-pickup"
            @click="$bvModal.show('callPickup')"
            v-b-modal.modalCallToPickup
            v-if="enableFlashExpress">
            <img
              class="fle-icon"
              src="../../../public/img/courier_icons/FLE.jpg" />
            กดเปิด Booking
          </button>
        </div>
      </div>
    </base-header>
    <b-modal
      ref="callPickup"
      id="modalCallToPickup"
      hide-footer
      title="เงื่อนไขการใช้งาน"
      @hidden="closeModalPickup">
      <card shadow type="secondary" class="m--4">
        <form>
          <template>
            <template v-if="pickup.completed">
              <div>
                <div class="col-lg-12 text-center">
                  <span
                    class="fa-stack fa-2x"
                    v-bind:class="{
                      'text-success': !pickup.error,
                      'text-danger': pickup.error,
                    }">
                    <i class="fa fa-circle fa-stack-2x"></i>
                    <i class="fa fa-truck fa-stack-1x fa-inverse"></i>
                  </span>
                  <br />
                  <p v-if="pickup.error" class="text-danger">
                    {{ pickup.error }}
                  </p>
                  <p v-else>เงื่อนไขการใช้งาน</p>

                  <div v-if="picker.length">
                    <div v-for="staff in picker" :key="staff.staffName">
                      <p v-if="staff.staffName">
                        ชื่อเจ้าหน้าที่: {{ staff.staffName }}
                      </p>
                      <p v-if="staff.staffPhone">
                        เบอร์โทร: {{ staff.staffPhone }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="!pickup.showButton">
              <div>
                <p class="text-center">
                  ขณะนี้ยังไม่สามารถกดเรียกขนส่งเข้ารับได้<br />กรุณากดเรียกใหม่ภายหลังเวลา
                  14.00 น.
                </p>
              </div>
            </template>
            <template v-else>
              <div class="col-lg-12">
                <div class="alert alert-shippop-info">
                  เปิดรายการ Booking ของขนส่ง Flash
                  เพื่อให้พนักงานสามารถรับพัสดุได้ 3 กรณีดังนี้
                  <ul>
                    <li>พนักงานสามารถเข้ารับได้หากทำรายการหลัง 14.00น.</li>
                    <li>พนักงานปิด Booking ขณะยังรับงานไม่ครบ</li>
                    <li>Shop สามารถนำพัสดุไปส่งเองที่ขนส่งแฟลช</li>
                  </ul>
                  หมายเหตุ: สามารถกดได้หลัง 14.00น.
                  โดยเงื่อนไขเป็นไปตามที่ขนส่งกำหนด
                </div>

                <div class="form-group">
                  <label>
                    <span class="text-danger">*</span> หมายเลขพัสดุ
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength="15"
                    placeholder="หมายเลขพัสดุของขนส่งแฟลช เช่น TH01374NTD7A"
                    :class="{
                      'is-invalid':
                        ($v.pickup.trackingCode.$dirty &&
                          !$v.pickup.trackingCode.isTrackingCode) ||
                        (pickup.submitted && $v.pickup.trackingCode.$invalid),
                    }"
                    v-model="$v.pickup.trackingCode.$model"
                    :readonly="busy" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label> <span class="text-danger">*</span> จำนวนพัสดุ </label>
                  <input
                    type="number"
                    min="1"
                    class="form-control"
                    placeholder="จำนวนพัสดุ"
                    :class="{
                      'is-invalid':
                        pickup.submitted && $v.pickup.numOfParcel.$invalid,
                    }"
                    :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                    v-model="pickup.numOfParcel"
                    :readonly="busy" />
                </div>
              </div>
            </template>

            <div
              slot="modal-footer"
              class="w-100 text-right"
              v-if="!pickup.completed && pickup.showButton">
              <b-button variant="secondary" @click="closeModalPickup"
                >ยกเลิก</b-button
              >
              <b-button
                variant="success"
                type="submit"
                @click="callToPickup()"
                :disabled="
                  $v.pickup.trackingCode.$invalid ||
                  $v.pickup.numOfParcel.$invalid
                "
                >ยืนยัน</b-button
              >
            </div>
          </template>
        </form>
      </card>
    </b-modal>
    <MadalRemark
      :getShow="modal_remark.show"
      :submit="modalBtnSubmit"
      :getDetails="modal_remark.data">
      <template slot="custom-header-order_log_update">
        <h3>{{ "พัสดุมีการอัพเดท มีรายละเอียดดังนี้" }}</h3>
      </template>
      <template slot="custom-weight">{{
        "น้ำหนัก " + $THEME.unitKG ? "(กิโลกรัม)" : "(กรัม)"
      }}</template>
      <template slot="custom-dimension">{{ "ขนาดพัสดุ (กxยxส ซม.)" }}</template>
      <template slot="custom-length">{{ "x" }}</template>
      <template slot="custom-height">{{ "x" }}</template>
      <template slot="custom-cost">{{ "ต้นทุน" }}</template>
      <template slot="custom-rate">{{ "ต้นทุนร้านค้า" }}</template>
      <template slot="custom-price">{{ "ราคาขาย" }}</template>
      <template slot="custom-created_at">{{ "วันที่สร้างรายการ" }}</template>
    </MadalRemark>
    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row">
                <div class="col-12 col-md-12 col-lg-12 col-xl-5">
                  <b-form-group
                    label="ค้นหาวันที่ขายพัสดุ (วันเริ่มต้น - วันสุดท้าย)"
                    class="mb-0">
                    <div class="row">
                      <div class="col-8 col-md-8 col-lg-8">
                        <date-range-picker
                          class="w-100"
                          :opens="'center'"
                          :singleDatePicker="false"
                          :appendToBody="true"
                          :ranges="false"
                          :closeOnEsc="false"
                          :autoApply="true"
                          :locale-data="{ format: 'dd/mm/yyyy' }"
                          v-model="filters">
                        </date-range-picker>
                      </div>
                      <div class="col-4 col-md-3 col-lg-2">
                        <button
                          class="btn btn-info btn-sm-res"
                          v-on:click="getReportTransport('date')">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </b-form-group>
                  <hr class="d-md-none d-lg-none" />
                </div>
                <div class="col-12 col-md-7 col-lg-8 col-xl-5 mb-3">
                  <div class="row">
                    <b-form-group
                      id="input-group-1"
                      label="ค้นหาข้อมูล"
                      label-for="input-1"
                      class="mb-0 col-6">
                      <b-form-input
                        v-model="filter"
                        id="input-1"
                        type="text"
                        required
                        placeholder></b-form-input>
                    </b-form-group>
                    <b-form-group
                      id="input-group-1"
                      label="ค้นหาขนส่ง"
                      label-for="input-1"
                      class="mb-0 col-6">
                      <select
                        class="form-control"
                        @click.stop.prevent
                        v-model="selectFilter">
                        <option :value="undefined">ทั้งหมด</option>
                        <option
                          :value="option"
                          v-for="option in options"
                          :key="option">
                          {{ option }}
                        </option>
                      </select>
                    </b-form-group>
                  </div>
                  <hr class="d-block d-md-none d-lg-none mb-0" />
                </div>
                <div class="col-12 col-md-5 col-lg-2 col-xl-2">
                  <b-form-group label="Export File" class="mb-0 pb-2">
                    <div
                      class="btn-group btn-sm-res btn-export"
                      role="group"
                      aria-label="Basic example">
                      <vue-excel-xlsx
                        :data="$THEME.exportLoading || formatExcel"
                        :columns="column"
                        :filename="'สรุปยอดการขายพัสดุ ' + date_excel"
                        :sheetname="'สรุปยอดการขายพัสดุ ' + date_excel">
                        excel
                      </vue-excel-xlsx>
                      <b-button
                        variant="info"
                        class="btn-sm-res"
                        @click="$htmlToPaper('tablePrint')"
                        >print</b-button
                      >
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3 mb-md-0">
                  <b-form-group
                    description="( หมายเลขใบเสร็จ , หมายเลข TRACKING )"
                    label="ค้นหาข้อมูล"
                    class="mb-0">
                    <div class="row">
                      <div class="col-4 col-lg-3 col-md-4 col-xl-2">
                        <select
                          class="form-control"
                          @click.stop.prevent
                          v-model="search.type">
                          <option value="receipt">{{ "เลขที่ใบเสร็จ" }}</option>
                          <option value="tracking">
                            {{ "หมายเลข TRACKING" }}
                          </option>
                        </select>
                      </div>
                      <div class="col-4 col-lg-3 col-md-4 col-xl-2">
                        <b-form-input
                          type="text"
                          v-model="search.receipt_tracking"
                          placeholder="ค้นหาข้อมูล">
                        </b-form-input>
                      </div>
                      <div class="col col-lg-2 col-md-2">
                        <button
                          class="btn btn-info btn-sm-res"
                          @click="getReportTransport('receipt_tracking')">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div id="tablePrint">
              <b-table
                show-empty
                responsive
                :items="itemFilter"
                :fields="fields"
                :busy="busy"
                class="scroll-bar-pop table-sticky text-center"
                foot-clone>
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template slot="index" slot-scope="data">{{
                  data.index + 1
                }}</template>
                <template slot="created_at" slot-scope="row">{{
                  row.item.created_at.date | dateFormat
                }}</template>
                <template slot="receipt_no" slot-scope="row">
                  <!-- <router-link tag="a" :to="`/cancelorders/${row.item.order_details_id}`">{{row.item.receipt_no}}</router-link> -->
                  {{ row.item.receipt_no }}
                </template>
                <template slot="status" slot-scope="row">
                  <b-badge
                    :variant="statusCourier(row.item.status).color + ' report'">
                    {{ statusCourier(row.item.status).status }}
                  </b-badge>
                </template>
                <template slot="dimension" slot-scope="row">
                  {{ row.item.dimension.width }} x
                  {{ row.item.dimension.length }} x
                  {{ row.item.dimension.height }}
                </template>
                <template slot="sender" slot-scope="row">
                  ชื่อ: {{ row.item.sender.name }} โทร:
                  {{ row.item.sender.phone }}
                </template>
                <template slot="rate" slot-scope="row">{{
                  row.item.rate | numFormat("0,0.00")
                }}</template>
                <template slot="price" slot-scope="row">{{
                  row.item.price | numFormat("0,0.00")
                }}</template>
                <template slot="fee" slot-scope="row">{{
                  row.item.fee | numFormat("0,0.00")
                }}</template>
                <template slot="profit" slot-scope="row">{{
                  row.item.profit | numFormat("0,0.00")
                }}</template>
                <template slot="total_price" slot-scope="row">{{
                  row.item.price | numFormat("0,0.00")
                }}</template>
                <template slot="delivery_no" slot-scope="row">
                  <router-link
                    :to="`/delivery/${row.item.delivery_id}`"
                    target="_blank"
                    class="px-1"
                    v-if="row.item.delivery_id !== null">
                    {{ row.item.delivery_no }}
                  </router-link>
                  <span v-else>{{ "-" }}</span>
                </template>
                <template slot="remark" slot-scope="row">
                  <template v-if="row.item.remark.status">
                    <b-button
                      variant="link"
                      @click="remarkDetails(row.item.remark)"
                      >ดูรายละเอียด</b-button
                    >
                  </template>
                  <template v-else> - </template>
                </template>

                <template slot="weight" slot-scope="row">
                  {{
                    row.item.weight
                      ? $THEME.unitKG
                        ? row.item.weight / 1000
                        : row.item.weight
                      : "-"
                  }}
                </template>

                <template slot="FOOT_index">รวม</template>
                <template slot="FOOT_created_at"> &nbsp;</template>
                <template slot="FOOT_status"> &nbsp;</template>
                <template slot="FOOT_postcode"> &nbsp;</template>
                <template slot="FOOT_name"> &nbsp;</template>
                <template slot="FOOT_receipt_no"> &nbsp;</template>
                <template slot="FOOT_tel"> &nbsp;</template>
                <template slot="FOOT_barcode"> &nbsp; </template>
                <template slot="FOOT_courier">&nbsp; </template>
                <template slot="FOOT_weight"> &nbsp;</template>
                <template slot="FOOT_dimension"> &nbsp;</template>
                <template slot="FOOT_sender"> &nbsp;</template>
                <template slot="FOOT_cashier"> &nbsp;</template>
                <template slot="FOOT_delivery_no"> &nbsp;</template>
                <template slot="FOOT_remark"> &nbsp;</template>
                <template slot="FOOT_cost">{{
                  footerTotal.cost | numFormat("0,0.00")
                }}</template>
                <template slot="FOOT_rate">{{
                  footerTotal.rate | numFormat("0,0.00")
                }}</template>
                <template slot="FOOT_remote_area">{{
                  footerTotal.remote_area | numFormat("0,0.00")
                }}</template>
                <template slot="FOOT_price">{{
                  footerTotal.price | numFormat("0,0.00")
                }}</template>
                <template slot="FOOT_fee">{{
                  footerTotal.fee | numFormat("0,0.00")
                }}</template>
                <template slot="FOOT_profit">{{
                  footerTotal.profit | numFormat("0,0.00")
                }}</template>
                <template slot="FOOT_cod_amount">{{
                  footerTotal.cod_amount | numFormat("0,0.00")
                }}</template>
                <template slot="FOOT_total_price">{{
                  footerTotal.total_price | numFormat("0,0.00")
                }}</template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import validatePop from "../../plugins/validatePop.js";
import { required } from "vuelidate/lib/validators";
// import PageVisitsTable from "../Dashboard/PageVisitsTable"
import MadalRemark from "@/components/Modals/Modal-remark";
import moment from "moment";
import { statusCourier } from "@/plugins/statusCourier.js";

const API_URL = process.env.VUE_APP_API;
export default {
  data() {
    return {
      picker: [],
      pickup: {
        trackingCode: "",
        numOfParcel: 1,
        submitted: false,
        completed: false,
        showButton: true, //new Date().getHours()>13?true:false
      },
      itemProduct: [],
      itemExportXLSX: [],
      enableFlashExpress: false,
      selectFilter: undefined,
      busy: true,
      userLogin: "",
      filter: "",
      filters: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      date_excel: moment().format("DD-MM-YYYY"),
      search: {
        type: "receipt",
        receipt_tracking: "",
      },
      modal_remark: {
        show: false,
        data: {},
      },
      statusCourier: statusCourier,
    };
  },
  components: {
    // PageVisitsTable,
    MadalRemark,
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  },
  validations: {
    pickup: {
      numOfParcel: { required },
      trackingCode: {
        required,
        isTrackingCode(value) {
          return /^TH\w+$/gi.test(value);
        },
      },
    },
  },
  created() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
  },
  mounted() {
    this.getReportTransport("date");
    const enableFlash = this.checkCourierAvailable("FLE");
    if (!enableFlash.data.available) {
      this.checkCourierAvailable("FLEWP");
    }
  },
  methods: {
    checkCourierAvailable(courier_code) {
      this.$http
        .post(
          API_URL + "/courier-available",
          {
            courier_code,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let resData = res.data;
          let checkError = validatePop(resData);
          this.busy = false;
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            return false;
          }
          if (resData.data.available) {
            this.enableFlashExpress = resData.data.available;
            return resData.data.available;
          }
        });
    },
    resetPickupModal() {
      this.picker = [];
      this.pickup.trackingCode = "";
      this.pickup.numOfParcel = 1;
      this.pickup.completed = false;
      this.pickup.submitted = false;
    },
    IsJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    closeModalPickup() {
      this.resetPickupModal();
      this.$bvModal.hide("modalCallToPickup");
    },
    callToPickup() {
      this.pickup.submitted = true;
      //TH01374NTD7A
      this.busy = true;
      this.$http
        .post(
          this.$API_URL + "/calltopickup",
          {
            tracking_code: this.pickup.trackingCode,
            num_of_parcel: this.pickup.numOfParcel,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          const result = res.data;
          let checkError = validatePop(res);
          this.pickup.completed = true;
          this.$v.$reset();
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.pickup.error = checkError.msg;
            this.busy = false;
            return false;
          }
          if (result.status) {
            let courierPicker = result.data.data;
            // console.log(courierPicker);
            if (courierPicker.length) {
              courierPicker = this.IsJsonString(result.data.data.response_data)
                ? JSON.parse(result.data.data.response_data)
                : courierPicker;
            } else {
              courierPicker = this.IsJsonString(courierPicker.response_data)
                ? JSON.parse(courierPicker.response_data).data
                : courierPicker;
            }
            this.picker = [];
            courierPicker.map((x) => {
              const pickupInfo = x.pickupInfo;
              this.picker.push({
                staffName: pickupInfo.staffName,
                staffPhone: pickupInfo.staffPhone,
                created_at: result.data.data.created_at,
              });
            });
          }

          this.busy = false;
        });
    },
    getReportTransport(filter) {
      this.busy = true;
      let dateStart = moment(this.filters.startDate).format("YYYY-MM-DD");
      let dateEnd = moment(this.filters.endDate).format("YYYY-MM-DD");
      this.$http
        .post(
          API_URL + "/shop/check",
          {
            ...(filter == "date"
              ? { start: dateStart, end: dateEnd }
              : { start: false, end: false }),
            type: "ship",
            ...(filter == "receipt_tracking" && this.search.type == "receipt"
              ? { receipt: this.search.receipt_tracking }
              : filter == "receipt_tracking" && this.search.type == "tracking"
              ? { tracking_code: this.search.receipt_tracking }
              : {}),
          },
          {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.busy = false;
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.itemProduct = res.data.data.items;
          this.itemProduct.forEach((data, i) => {
            this.itemProduct[i].date_created = data.created_at.date;
          });
          this.busy = false;
        });
    },
    isAdmin() {
      return this.userLogin.role === "admin";
    },
    isSuperAdmin() {
      return this.userLogin.role === "superadmin";
    },
    remarkDetails(data) {
      let parcel_updated = data.data.order_log_update;
      let send = {
        status: data.status,
        data: {
          order_log_update: {
            dimension: { width: "", length: "", height: "" },
          },
        },
      };
      for (let key in parcel_updated) {
        if (["width", "length", "height"].includes(key)) {
          send.data.order_log_update.dimension[key] = parcel_updated[key];
        } else {
          send.data.order_log_update[key] = parcel_updated[key];
        }
      }
      this.modal_remark.data = send;
      this.modal_remark.show = true;
    },
    modalBtnSubmit() {
      this.modal_remark.show = false;
    },
    setFormatRemark(data) {
      if (!data.status) return `-`;

      let res = `พัสดุมีการอัพเดท มีรายละเอียดดังนี้\r\nน้ำหนัก (กรัม): ${data.data.order_log_update.weight} \r\nขนาดพัสดุ (กxยxส ซม.) :${data.data.order_log_update.width}x${data.data.order_log_update.length}x${data.data.order_log_update.height} \r\nต้นทุน : ${data.data.order_log_update.cost} \r\nต้นทุนร้านค้า : ${data.data.order_log_update.rate} \r\nราคาขาย : ${data.data.order_log_update.price} \r\nวันที่สร้างรายการ : ${data.data.order_log_update.created_at}`;

      if (this.isAdmin())
        return (res = `พัสดุมีการอัพเดท มีรายละเอียดดังนี้\r\nน้ำหนัก : ${data.data.order_log_update.weight}  \r\nขนาดพัสดุ (กxยxส ซม.) :${data.data.order_log_update.width}x${data.data.order_log_update.length}x${data.data.order_log_update.height} \r\nต้นทุน : ${data.data.order_log_update.rate} \r\nราคาขาย : ${data.data.order_log_update.price} \r\nวันที่สร้างรายการ : ${data.data.order_log_update.created_at}`);

      if (!this.isAdmin() && !this.isSuperAdmin())
        return (res = `พัสดุมีการอัพเดท มีรายละเอียดดังนี้\r\nน้ำหนัก : ${data.data.order_log_update.weight} \r\nขนาดพัสดุ (กxยxส ซม.) :${data.data.order_log_update.width}x${data.data.order_log_update.length}x${data.data.order_log_update.height} \r\nราคาขาย : ${data.data.order_log_update.price} \r\nวันที่สร้างรายการ : ${data.data.order_log_update.created_at}`);

      return res;
    },
  },
  showErrorModal(msgBody) {
    this.$bvModal.msgBoxOk(msgBody, {
      title: "ERROR",
      size: "sm",
      buttonSize: "sm",
      okVariant: "danger",
      okTitle: "ลองอีกครั้ง",
      contentClass: "modal-errors",
      headerClass: "p-2 border-bottom-0",
      footerClass: "p-2 border-top-0",
      centered: true,
    });
  },
  computed: {
    column() {
      let columns = [
        {
          label: "วันที่สร้างรายการ",
          field: "date_created",
          dataFormat: (value) => {
            return value ? `${this.$options.filters.dateFormat(value)}` : "รวม";
          },
        },
        {
          label: "เลขที่ใบเสร็จ",
          field: "receipt_no",
        },
        {
          label: "สถานะ",
          field: "status",
          dataFormat: (value) => {
            return value ? this.statusCourier(value).status : "";
          },
        },
        {
          label: "ผู้รับ",
          field: "name",
        },
        {
          label: "ที่อยู่",
          field: "address",
        },
        {
          label: "รหัส ปณ",
          field: "postcode",
        },
        {
          label: "โทร",
          field: "tel",
          dataFormat: (value) => {
            return ` ${value}`;
          },
        },
        {
          label: "รายละเอียดผู้ส่ง",
          field: "sender",
          dataFormat: (value) => {
            return value ? `ชื่อ: ${value.name} โทร : ${value.phone}` : "";
          },
        },
        {
          label: "tracking",
          field: "barcode",
        },
        {
          label: "ขนส่ง",
          field: "courier",
        },
        {
          label: "น้ำหนัก",
          field: "weight",
          dataFormat: (value) => {
            return value
              ? this.$THEME.unitKG
                ? `${value / 1000}`
                : `${value}`
              : "";
          },
        },
        {
          label: "ขนาดพัสดุ กxยxส(ซม.)",
          field: "dimension",
          dataFormat: (value) => {
            return value
              ? ` ${value.width}x${value.length}x${value.height}`
              : "";
          },
        },
        {
          label: "ราคาต้นทุน",
          field: "rate",
          dataFormat: (value) => {
            return `${this.$options.filters.numFormat(value, "0,0.00")}`;
          },
        },
        {
          label: "ค่าบริการพื้นที่พิเศษ",
          field: "remote_area",
          dataFormat: (value) => {
            return `${this.$options.filters.numFormat(value, "0,0.00")}`;
          },
        },
        {
          label: "ราคาขาย",
          field: "price",
          dataFormat: (value) => {
            return `${this.$options.filters.numFormat(value, "0,0.00")}`;
          },
        },
        {
          label: "ค่าธรรมเนียม",
          field: "fee",
          dataFormat: (value) => {
            return `${this.$options.filters.numFormat(value, "0,0.00")}`;
          },
        },
        {
          label: "กำไร",
          field: "profit",
          dataFormat: (value) => {
            return `${this.$options.filters.numFormat(value, "0,0.00")}`;
          },
        },
        {
          label: "ราคารวม",
          field: "total_price",
          dataFormat: (value) => {
            return `${this.$options.filters.numFormat(value, "0,0.00")}`;
          },
        },
        {
          label: "ยอดเรียกเก็บ COD",
          field: "cod_amount",
          dataFormat: (value) => {
            return `${this.$options.filters.numFormat(value, "0,0.00")}`;
          },
        },
        {
          label: "cashier",
          field: "cashier",
        },
        {
          label: "หมายเหตุ",
          field: "remark",
          dataFormat: (value) => {
            return value ? this.setFormatRemark(value) : "";
          },
        },
      ];
      if (this.isAdmin() || this.isSuperAdmin()) {
        return columns;
      } else {
        return columns.filter(function (col) {
          return (
            ["ค่าธรรมเนียม", "กำไร", "ราคาขาย", "ราคาต้นทุน"].indexOf(
              col.label
            ) < 0
          );
        });
      }
    },
    fields() {
      let fields = [
        { key: "index", label: "ลำดับ", sortable: true },
        { key: "created_at", label: "วันที่สร้างรายการ", sortable: true },
        {
          key: "receipt_no",
          label: "เลขที่ใบเสร็จ",
          sortable: true,
        },
        { key: "status", label: "สถานะ", sortable: true },
        {
          key: "postcode",
          label: "รหัสไปรษณีย์ผู้รับ",
          sortable: true,
          class: "text-center",
        },
        {
          key: "name",
          label: "ชื่อผู้รับ",
          sortable: true,
          class: "text-center",
        },
        {
          key: "tel",
          label: "หมายเลขโทรศัพท์ผู้รับ",
          sortable: true,
          class: "text-center",
        },
        {
          key: "sender",
          label: "รายละเอียดผู้ส่ง",
          sortable: true,
          class: "text-center",
        },
        {
          key: "barcode",
          label: "หมายเลข Tracking",
          sortable: true,
          class: "text-center",
        },
        { key: "courier", label: "ชื่อขนส่ง", sortable: true },
        { key: "weight", label: "น้ำหนัก", sortable: true },
        { key: "dimension", label: "ขนาดพัสดุ (ซม.)", sortable: true },
        { key: "rate", label: "ราคาต้นทุน", sortable: true },
        { key: "remote_area", label: "ค่าบริการพื้นที่พิเศษ", sortable: true },
        { key: "price", label: "ราคาขาย", sortable: true },
        { key: "cod_amount", label: "ยอดเรียกเก็บ COD", sortable: true },
        { key: "fee", label: "ค่าธรรมเนียม", sortable: true },
        { key: "profit", label: "กำไร", sortable: true },
        { key: "total_price", label: "ราคารวม", sortable: true },
        { key: "cashier", label: "Cashier", sortable: true },
        { key: "delivery_no", label: "เลขที่ใบนำส่งพัสดุ No.", sortable: true },
        { key: "remark", label: "หมายเหตุ", sortable: true },
      ];
      if (!this.isAdmin() && !this.isSuperAdmin()) {
        return fields.filter(function (col) {
          return ["rate", "profit"].indexOf(col.key) < 0;
        });
      }

      return fields;
    },
    itemFilter() {
      let item = this.itemProduct.filter((item) => {
        let keys = Object.keys(item);
        if (this.selectFilter === undefined && !this.filter) {
          return true;
        } else if (this.selectFilter === undefined && this.filter) {
          return Object.values(item).some((val) => {
            return String(val)
              .toLowerCase()
              .includes(this.filter.toLowerCase());
          });
        } else if (this.selectFilter !== undefined && !this.filter) {
          return item.courier === this.selectFilter;
        } else if (this.selectFilter !== undefined && this.filter) {
          return (
            item.courier === this.selectFilter &&
            Object.values(item).some((val) => {
              return String(val)
                .toLowerCase()
                .includes(this.filter.toLowerCase());
            })
          );
        }
      });
      item.forEach((val) => {
        val.profit = +val.price - val.rate;
        val.rate = val.rate - val.fee;
        val.total_price = val.price;
        // console.log( val )
      });
      return item;
      //     return this.filter
      // ? this.itemProduct.filter(item => item.name.includes(this.filter) || item.cashier.includes(this.filter) || item.receipt_no.includes(this.filter))
      // : this.itemProduct
    },
    options() {
      // This could be simplified if the select was it's own component.
      let options = {};

      const vals = this.itemProduct.map((item) => item.courier);

      options = Array.from(new Set(vals));

      return options;
    },
    total() {
      return this.itemFilter.reduce((total, product) => {
        return product.status != "PENDING_CANCEL" && product.status != "CANCEL"
          ? total + Number(product.price)
          : total;
      }, 0);
    },
    footerTotal() {
      let total = {
        cost: 0,
        price: 0,
        rate: 0,
        remote_area: 0,
        fee: 0,
        profit: 0,
        cod_amount: 0,
        total_price: 0,
      };
      this.itemFilter.forEach((item) => {
        if (item.status != "PENDING_CANCEL" && item.status != "CANCEL") {
          total.cost += +item.cost;
          total.price += +item.price;
          total.rate += +item.rate;
          total.remote_area += +item.remote_area;
          total.fee += +item.fee;
          total.profit += +item.profit;
          total.total_price += +item.total_price;
          total.cod_amount += +item.cod_amount;
        }
      });
      return total;
    },
    formatExcel() {
      let data = [...this.itemFilter];
      if (this.itemFilter.length > 0) {
        let format = {
          date_created: "",
          receipt_no: "",
          status: "",
          name: "",
          address: "",
          postcode: "",
          tel: "",
          sender: "",
          barcode: "",
          courier: "",
          weight: "",
          dimension: "",
          rate: this.footerTotal.rate,
          remote_area: this.footerTotal.remote_area,
          price: this.footerTotal.price,
          fee: this.footerTotal.fee,
          profit: this.footerTotal.profit,
          total_price: this.footerTotal.total_price,
          cod_amount: this.footerTotal.cod_amount,
          cashier: "",
          remark: "",
        };
        data.push(format);
      }
      return data;
    },
  },
};
</script>

<style></style>
